<script>
	// Componentes Svelte
    import { Router, Link, link , Route } from "svelte-routing";
    import PageHeader from './../components/PageHeader.svelte';

</script>

<section class="conteudo-internas">
    <PageHeader title="Oops, aconteceu um imprevisto..."></PageHeader>
    <div class="container">
        <p>Mas fique tranquilo, deixe seu recado que retornaremos com o imóvel ideal para você! <a class="color-primary" href="/contato" title="Clique aqui para fala com nossa equipe" use:link replace>Clique aqui</a> para entrar em contato com a nossa equipe.
        <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
        </p>
    </div>
</section>